import { TranslatableText } from 'component/translation';
import { component, demoFile } from 'system/demo';
import { t } from 'util/stdtypes';

demoFile('component/translation');

component('TranslatableText', TranslatableText, {
    args: { label: t('Member') },
    state: { modulePublic: { language: 'french_canadian' } },
});
